export default __webpack_public_path__ + "static/media/home-logo.ae6a5931.svg";